import TwoStepVerificationModal from './TwoStepVerificationModal';

export default TwoStepVerificationModal;
